import Pages from './pages';



const App = () => <Pages />;
export default App;
